import { createAsyncThunk } from '@reduxjs/toolkit';
import callApi from '../../utils/api/callAPI';

export const fetchProductPricing = createAsyncThunk(
  'get/sale_products/v3/product_pricing',
  async ({ key, params }, { dispatch }) => {
    try {
      const res = await callApi({
        endpoint: 'sale_products/v3/product_pricing',
        method: 'get',
        params,
      });

      const response = res.data;
      if (response.success) {
        return {
          data: response.result?.data,
          key,
          params,
        };
      } else {
        throw response;
      }
    } catch (error) {
      dispatch({ type: 'fail', payload: error });
      return {
        error: error.message,
      };
    }
  }
);
